const DECIMAL_PATTERN = /^(?:0|[1-9]\d*)(?:\.(\d+))?$/;

export function parseTokenAmount(value: string, decimals: number): bigint {
  const normalized = value.trim();
  if (!Number.isInteger(decimals) || decimals < 0 || decimals > 18) {
    throw new Error('Token decimals must be between 0 and 18.');
  }
  const match = DECIMAL_PATTERN.exec(normalized);
  if (!match) throw new Error('Enter a positive decimal amount without commas or scientific notation.');

  const fraction = match[1] ?? '';
  if (fraction.length > decimals) throw new Error(`This token supports at most ${decimals} decimal places.`);
  const [whole = '0'] = normalized.split('.');
  const baseUnits = BigInt(whole) * 10n ** BigInt(decimals)
    + BigInt((fraction + '0'.repeat(decimals)).slice(0, decimals) || '0');
  if (baseUnits <= 0n) throw new Error('Amount must be greater than zero.');
  return baseUnits;
}

export function formatTokenAmount(value: bigint, decimals: number, maximumFractionDigits = 6): string {
  const negative = value < 0n;
  const absolute = negative ? -value : value;
  const divisor = 10n ** BigInt(decimals);
  const whole = absolute / divisor;
  if (decimals === 0) return `${negative ? '-' : ''}${whole}`;

  const fraction = (absolute % divisor).toString().padStart(decimals, '0');
  const visible = fraction.slice(0, Math.max(0, maximumFractionDigits)).replace(/0+$/, '');
  return `${negative ? '-' : ''}${whole}${visible ? `.${visible}` : ''}`;
}


